





























import { Component, Vue, Watch } from 'vue-property-decorator';
import { getDefaultAloForgottenPass } from '../models/alo/AloForgottenPass';

@Component({
  name: 'Login',  
})
export default class Login extends Vue {
  
  UserName = ''
  Password = ''
  Mail = ''
  dirtyEmail = false
  dirtyPwd = false
  forgotpass = false
  loading = false
  
  get authStatus() {
    switch(this.$store.myGetters.authStatus){
      case "AuthenticationProgress":
        return this.$t('Login.AuthenticationProgress')
      case "AuthenticationSuccess":
        return this.$t('Login.AuthenticationSuccess')
      case "AuthenticationError":
        return this.$t('Login.AuthenticationError')     
      case "PassForgottenSuccess":
        return this.$t('Login.PassForgottenSuccess')  
      case "PassForgottenProgress":
        return this.$t('Login.PassForgottenProgress')  
      case "PassForgottenError":
        return this.$t('Login.PassForgottenError') 
      default:
        return ''        
    }
  }

  get redirectPath(){
      return this.$store.myGetters.redirectPath
  }

  
  beforeDestroy() {

  }
  
  @Watch("dirtyEmail")
  dirtyEmailChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.UserName.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch("dirtyPwd")
  dirtyPwdChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.Password.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }
  
  mounted(){
    this.hackToSolveAutoFillIssue()  
    this.$store.myActions.AUTH_RESET_STATUS()
  }

  hackToSolveAutoFillIssue(){
    let times = 0;
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyEmail && this.dirtyPwd) || times === 30) {
        clearInterval(interval)
      }
      else{
        this.dirtyEmail = !!document.querySelector('input[name="UserName"]:-webkit-autofill')
        this.dirtyPwd = !!document.querySelector('input[name="Password"]:-webkit-autofill')
      }
    }, 100)
  }
    
  submit() {     
    this.loading = true   
    if(this.forgotpass){
      const {UserName,Mail} = this    
      this.$store.myActions.AUTH_PASSWORD_REQUEST({ 
        ...getDefaultAloForgottenPass(),
        userEmail:UserName
      }).finally(() => {
        this.loading = false
      })
    }
    else{
      const {UserName, Password} = this    
      this.$store.myActions.AUTH_REQUEST({ userEmail:UserName, userPass:Password }).then(() => {                    
        this.$router.push(this.redirectPath)
      }).finally(() => {
        this.loading = false
      })
    }
  }  

  forgotpassword() {
    this.$store.myActions.AUTH_RESET_STATUS()
    this.forgotpass = !this.forgotpass
  }
}
